import React from "react";
import {
  Col,
  Row,
  Form,
  Button,
  Input,
  Space,
  message,
  DatePicker,
  Select,
} from "antd";
import { reportService } from "_services";
import moment from "moment";

function MudFormsSearch({ showSearchLoading, onSearchResults }) {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    showSearchLoading(true);

    let searchParams = [];

    if (values.issueNumber) {
      searchParams.push(`issueNumber=${values.issueNumber}`);
    }
    if (values.mudReferenceNumber) {
      searchParams.push(`mudReferenceNumber=${values.mudReferenceNumber}`);
    }
    if (values.customReferenceNumber) {
      searchParams.push(
        `customReferenceNumber=${values.customReferenceNumber}`
      );
    }

    if (values.orderStage) {
      searchParams.push(`orderStage=${values.orderStage}`);
    }

    if (values.mudDocumentDateRange) {
      searchParams.push(
        `fromDate=${encodeURIComponent(
          moment(values.mudDocumentDateRange[0])
            .startOf("day")
            .format("YYYY-MM-DD")
        )}&toDate=${moment(values.mudDocumentDateRange[1])
          .startOf("day")
          .format("YYYY-MM-DD")}`
      );
    }

    const queryString = searchParams.length ? `?${searchParams.join("&")}` : "";

    reportService
      .getMudFormSearch(queryString)
      .then((data) => {
        onSearchResults(data.content);
      })
      .catch((error) => {
        message.error(`${error}`);
        onSearchResults([]);
      });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
      initialValues={{ dateRange: moment() }}
    >
      <Row gutter={24}>
        <Col span={3}>
          <Form.Item label="CUS DEC No#" name="customReferenceNumber">
            <Input allowClear />
          </Form.Item>
        </Col>

        <Col span={3}>
          <Form.Item label="Issue No#" name="issueNumber">
            <Input allowClear />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item label="MUD Form No#" name="mudReferenceNumber">
            <Input allowClear />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item label="Status" name="orderStage">
            <Select placeholder="Select Status" allowClear>
              <Select.Option value="ISSUED">ISSUED</Select.Option>
              <Select.Option value="DELIVERED">DELIVERED</Select.Option>
              <Select.Option value="COMPLETE">COMPLETE</Select.Option>
            </Select>
          </Form.Item>
        </Col>

        <Col span={5}>
          <Form.Item name="mudDocumentDateRange" label="Date range">
            <DatePicker.RangePicker
              ranges={{
                Today: [moment(), moment()],
                "This Month": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
              }}
            />
          </Form.Item>
        </Col>

        <Col span={3} style={{ textAlign: "right" }}>
          <Space direction="horizontal" align="center">
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                onFinish({});
              }}
            >
              Clear
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
}
export default MudFormsSearch;
